import {createAction, props} from '@ngrx/store';
import { Auth } from '@core/models/auth.model';

export const login = createAction('[Login Page] User Login', props<Auth>());
export const loginSuccess = createAction('[Login Page] User Login Success', props<Auth>());
export const logout = createAction('[Top Menu] Logout');
export const updateAppPermissions = createAction('[App Permissions] Update', props<{appPermissions: any}>());
export const updateNavigations = createAction('[Navigations] Update', props<{navigations: any}>());